import { HttpError } from './types.js';

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError;
}
